export const BASE_URL = "https://api.huebits.in"; //https://api.huebits.in http://localhost:8000

export const  Brochurerequest= `${BASE_URL}/api/brochure-request`;
export const  Brochuredownload= `${BASE_URL}/api/download-brochure`;
export const  Brochurebrochurelist= `${BASE_URL}/api/download-brochure-list`;
export const  Sendenquiry= `${BASE_URL}/api/enquiry`;
export const  Sendenquirydownload= `${BASE_URL}/api/download-enquiries`;

//Razorpay
export const Razorpayorder = `${BASE_URL}/api/order`;
export const RazorpaypaymentCapture = `${BASE_URL}/api/payment-capture`;
export const RazorpayCreateCoupon = `${BASE_URL}/api/create-coupon`;
//export const RazorpayRefund = `${BASE_URL}/api/refund`;

//logout
export const Logout = `${BASE_URL}/api/logout`;
//Learnersapis
export const LearnersSignup = `${BASE_URL}/api/signup`;
export const LearnersVerifyCaptcha = `${BASE_URL}/api/verify-captcha`;
export const LearnersLogin = `${BASE_URL}/api/login`;
export const LearnersLoginVeficationOtp = `${BASE_URL}/api/login-vefication`;
export const LearnersSinglelogin = `${BASE_URL}/api/singlesignon`;
export const Learnersgooglelogin = `${BASE_URL}/api/auth/google/server`;
export const LearnersGenerateOtp = `${BASE_URL}/api/generate-otp`;
export const LearnersVerifyOtp = `${BASE_URL}/api/verify-otp`;
export const LearnersForgotPassword = `${BASE_URL}/api/forgot-password`;
export const LearnersProfile = `${BASE_URL}/api/learner-profile/`;
export const LearnersIdeavizeSSO = `${BASE_URL}/api/ideavize-sso`;
//export const LearnersupdateProfile = `${BASE_URL}/api/update-learner-profile/`;
export const LearnersResume = `${BASE_URL}/api/learner-resume`;
export const LearnersAddCourses = `${BASE_URL}/api/add-course`;
export const LearnersAddProjects = `${BASE_URL}/api/add-project`;
export const LearnersCourses = `${BASE_URL}/api/get-courses`;
export const LearnersProjects = `${BASE_URL}/api/get-projects`;
//export const LearnersCoursesProgress = `${BASE_URL}/api/coursesprogress`;
//export const LearnersProjectsProgress = `${BASE_URL}/api/coursesprogress`;
export const LearnersSubscription = `${BASE_URL}/api/search-learner-trans`;
export const LearnersDashboard = `${BASE_URL}/api/dashboard`;
export const LearnersLearningpath = `${BASE_URL}/api/learning-path`;
export const LearnersHiretech = `${BASE_URL}/api/hire-tech`
// export const LearnersLiveSessions = `${BASE_URL}/api/calendly/available-dates`;
export const LearnersLiveSessions = `${BASE_URL}/api/mentor/calendly/events`; 
export const LearnersBookevent = `${BASE_URL}/api/mentor/book-meeting`;
export const LearnersMentorFeedback = `${BASE_URL}/api/mentor-feedback`;
//learners applied
export const Organizationapplied = `${BASE_URL}/api/hire-tech/applied-jobs`;
export const Organizationapplyprojects = `${BASE_URL}/api/postprojects/apply-project`;
export const Organizationapplyjobs = `${BASE_URL}/api/hire-tech/apply-job`;
export const OrganizationapplyjobDetails = `${BASE_URL}/api/hire-tech/job-details`;
export const OrganizationapplyprojectsDetails = `${BASE_URL}/api/postprojects/applied`;
//Organizations
export const OrganizationsSignup = `${BASE_URL}/api/organizations-signup`;
export const OrganizationsLogin = `${BASE_URL}/api/organizations-signin`;
export const OrganizationsGenerateOtp = `${BASE_URL}/api/organizations-generate-otp`;
export const OrganizationsVerifyOtp = `${BASE_URL}/api/organizations-verify-otp`;
export const OrganizationsForgotPassword = `${BASE_URL}/api/organizations-forgot-password`;
export const OrganizationsPapup = `${BASE_URL}/api/organizations`;
export const OrganizationsSubmitproject = `${BASE_URL}/api/upload-project`;
export const OrganizationsCompaniesprofile = `${BASE_URL}/api/organizations-profile`;
export const OrganizationsDownloadreume = `${BASE_URL}/api/download-resume`;
export const Organizationsprojectsdata = `${BASE_URL}/api/postprojects/company`; 
export const OrganizationsupdateCompanyProject = `${BASE_URL}/api/postprojects/company`;
export const Organizationsprojectsfeedback = `${BASE_URL}/api/postprojects/company-feedback`;
export const OrganizationsallprojectsCompanyProject = `${BASE_URL}/api/postprojects`;
export const Organizationsuploads = `${BASE_URL}/api/uploads`;
export const OrganizationHiretech = `${BASE_URL}/api/hire-tech`;
export const OrganizationHiretechalldata = `${BASE_URL}/api/hire-tech`;
export const OrganizationHiretechupadate = `${BASE_URL}/api/hire-tech`;
export const OrganizationHiretechfeedback = `${BASE_URL}/api/hire-tect/post-feedback`;
export const OrganizationHiretechcopmany = `${BASE_URL}/api/hire-tech/company`; 
export const OrganizationHiretechishired = `${BASE_URL}/api/hire-tech/is-hired`; 
export const Organizationapplications = `${BASE_URL}/api/download-applications`;
export const Organizationagetlearners = `${BASE_URL}/api/get-learner`;
//Admindashboard
export const Adminsignup = `${BASE_URL}/api/admin-signup`;
export const Adminlogin = `${BASE_URL}/api/admin-login`;
export const AdminGenerateOtp = `${BASE_URL}/api/admin-generate-otp`;
export const AdminVerifyOtp = `${BASE_URL}/api/admin-verify-otp`;
export const AdminForgotPassword = `${BASE_URL}/api/admin-forgot-password`;
export const AdminLearnerslist = `${BASE_URL}/api/admin/learners`;
export const AdminLearnersuploads = `${BASE_URL}/uploads/`;
export const AdminOrganizationslist = `${BASE_URL}/api/admin/org-users`;
export const AdminOrganizationsuploads = `${BASE_URL}/uploads/`;